export const lang = {
	home : 'index',
	name : 'chinese',
	Best_sellers : 'Best Sellers',
	Business : 'Business',
	Support : 'Support',
	About_us : 'About Us',
	SDK : 'SDK',
	language : 'Chinese',
	
	Robot : 'Robot',
	Spray_disinfection:'Spray Disinfection',
	UVC_disinfection:'UVC Disinfection',
	Delivery : 'Delivery',
	Receptionist  : 'Receptionist',
	Companion :'Companion',
	Buy : 'Buy',
	Become_an_agent : 'Become An Agent',
	Our_customers:'Our Customers',
	After_sale_service : 'After Sale Service',
	Company_profile : 'Company Profile',
	News :'news information',
	Contact_us : 'Contact Us',
	Input_phone : 'Input Phone No.',
	For_details : 'inquiry',
	tel : '8613421340682',
	
	News1 :'More news',
	
	index1 : 'Star products',
	
	AI_database :'Self-developed cloud based AI database, natural language understanding and analysis system, SDK can be provided for secondary development. ',
	Material_MTPE :'Self-modified new polymer elastic material M-TPE, smoother, softer and more elastic than TPE, while its price is more competive than silicone.',
	Mobile_intelligent :'Self-developed multi-series fixed and mobile intelligent hardware platforms which fully support secondary development and sharing',

	Uniquely_designed :'Uniquely designed with multiple modes which can be voice controlled, AI Tech spray disinfection robot is the first spray disinfection robot with various smart disinfection modes in the world, and it allows for better user experience, more safety and effectiveness when disinfecting.',
	Omnidirectional :'3D omnidirectional obstacle avoidance',
	Equipped :'Equipped with ultrasonic + infrared sensors and a new modular chassis, this robot will stop when encountering obstacles from any angles,  then turn around and go away.',
	
	automatic_disinfection : 'The automatic disinfection robot is a programmable and most advanced robotic instrument manufactured by Shenzhen All Intelligent Robot Technology Company. You can used iPad to perform nightly disinfection controllers without manual intervention. Concentrated ultraviolet rays can effectively kill bacteria and other harmful microorganisms, with a maximum disinfection rate of 99.99%',
	Video_introduction : 'Video Introduction',
	uvc_title : 'Easy disinfection · Worth having',
	uvc_p : 'Independent patent mobile chassis, omni-directional obstacle avoidance; when encountering obstacles, it can immediately plan a new route and avoid according to the new route; 3D omni-directional obstacle avoidance, intelligent route planning and other technologies ensure that the machine can automatically complete the disinfection task, and can save manpower.',
	uvc_title1 : 'Ultraviolet sterilization · Environmentally friendly',
	uvc_p1 : 'Ultraviolet disinfection is the use of appropriate wavelength of ultraviolet radiation can destroy the molecular structure of DNA (deoxyribonucleic acid) or RNA (RNA) in microbial cells, resulting in the death of growth cells and (or) regenerative cells, so as to achieve the effect of sterilization and disinfection. Ultraviolet disinfection technology is based on modern epidemic prevention, medicine and photodynamic technology. It uses specially designed UVC band ultraviolet light to irradiate running water with high efficiency, high intensity and long life to kill all kinds of bacteria, viruses, parasites, algae and other pathogens in the water. Ultraviolet disinfection is a physical method. It does not add any substance to the water and has no side effects. This is the place where it is better than chlorination disinfection. It is usually used in combination with other substances. The common combined processes are UV + H2O2, UV + H2O2 + O3 and UV + TiO2. In this way, the disinfection effect will be better.',
	uvc_p2 : 'Application scenarios',
	uvc_p3 : 'Hospitals, factories, hotels, offices, etc',
	
	generation :'Based on a new generation of fully autonomous positioning and navigation solution, the robot uses laser slam technology and multi-sensor to be responsible for the delivery of restaurant dishes from the back kitchen to the table, and the customers who move to the waiting area cyclically deliver snacks, and can surprise birthday customers with birthday cakes. Service efficiency, help restaurants optimize staff, and bring additional value-added services.',
	Delivery1 : 'Product parameters',
	Delivery2 : 'Product name',
	Delivery3 : 'Intelligent Food Delivery Robot',
	Delivery4 : 'Product function',
	Delivery5 : 'Food delivery',
	Delivery6 : 'Maximum moving speed',
	Delivery7 : '0.5m/s',
	Delivery8 : 'height',
	Delivery9 : '120cm',
	Delivery10 : 'bearing',
	Delivery11 : '200kg',
	Delivery12 : 'Radar range',
	Delivery13 : '0.15m-16m',
	Delivery14 : 'Rated power',
	Delivery15 : '36V/15A 21A.H lithium battery',
	Delivery16 : 'network',
	Delivery17 : '4G、Wifi',
	Delivery18 : 'Physical structure',
	Delivery19 : 'Two or three layers can be selected, 36 * W35 * H25cm in length',
	Delivery20 : 'Chassis diameter',
	Delivery21 : '44cm',
	Delivery22 : 'Obstacle avoidance mode',
	Delivery23 : 'Lidar, ultrasonic',
	Delivery24 : 'Net weight',
	Delivery25 : '70KG',
	Delivery26 : 'Charging mode',
	Delivery27 : 'Automatic, manual',
	Delivery28 : 'customized',
	Delivery29 : 'OEM production, original factory',
	Delivery30 : 'Application scenarios: restaurants, hotpot shops, supermarkets, hotels...',
	
	welcome1 : 'Product parameters',
	welcome2 : 'Product name',
	welcome3 : 'Intelligent business Receptionist robot',
	welcome4 : 'Product function',
	welcome5 : '1. Etiquette: infrared induction, active voice communication, custom voice broadcast 2. Language: most Chinese dialects and English 3. Body movements: bending, bowing, saluting, waving, etc',
	welcome6 : 'Host voltage',
	welcome7 : 'DC36V, charging dc42v',
	welcome8 : 'network',
	welcome9 : '4G、WIFI',
	welcome10 : 'Body material',
	welcome11 : 'Advanced modified m-tpe',
	welcome12 : 'height',
	welcome13 : 'Standard 166cm, customizable',
	welcome14 : 'Total weight',
	welcome15 : '45KG',
	welcome16 : 'bones',
	welcome17 : 'Composite stainless steel',
	welcome18 : 'skin colour',
	welcome19 : 'Normal skin color, customizable',
	welcome20 : 'eyeball',
	welcome21 : 'Black, blue, green',
	welcome22 : 'Optional',
	
	buy1 : 'Buying products',
	buy2 : 'Shenzhen All Intelligent Technology',
	buy3 : 'Address: 101, building A6, Meiying (Phoenix) Zhihui Innovation Park, No.7 Xingye Third Road, Fenghuang community, Fuyong street, Baoan District, Shenzhen.',
	buy4 : 'tel:860755-23226813',
	buy5 : 'Mobile phone: + 86 13421340682  Susan',
	buy6 : 'wechat & WhatsApp: + 86 13421340682',
	buy7 : 'QQ：2571177189',
	buy8 : 'E-mail：info@ai-aitech.com',
	buy9 : 'Tel. + 86 075523226813',
	buy10 : 'Website address: www.ai-aitech.cn',
	buy11 : 'Alibaba: https://airobot1688.1688.com/',
	
	Sold1 : 'after-sale service',
	Sold2 : 'Service description',
	Sold3 : 'Provide 7 * 24 hours network consulting service.',
	Sold4 : 'Software part: one time purchase, lifetime free automatic upgrade.',
	Sold5 : 'Mechanical and electrical part: one year warranty, three years warranty. In one year, if there is non-human damage, the company provides free warranty.',
	Sold6 : 'One year later, within three years. The company provides paid maintenance and upgrade.',
	Sold7 : 'Note: if you are a consignment merchant, we have also recorded professional publicity videos and detailed instruction manual for you. We can also provide you with free technical training for sales engineers.',
	Sold8 : 'service content',
	Sold9 : '1-year warranty | 3-year warranty | free software upgrade | 24-hour consultation | free remote assistance',
	Sold10 : 'contact information',
	Sold11 : 'Address: 101, building A6, Meiying (Fenghuang) Zhihui Innovation Park, No.7 Xingye Third Road, Fenghuang community, Fuyong street, Bao an District, Shenzhen',
	Sold12 : 'Tel. + 86 075523226813',
	Sold13 : 'website: www.ai-aitech.com',
	Sold14 : 'Email: info@ai-aitech.com',
	
	about1 : 'AI-Tech',
	about2 : 'AI-Tech is Shenzhen All Intelligent Technology Co.，Ltd. ，Founded on August 18, 2016. As the name implies, AI tech is a national high-tech enterprise that develops, produces and sells artificial intelligence technology services and products. We are committed to building a practical new artificial intelligence technology and AI technology sharing platform with the mode of "combining virtual reality with reality and having both software and hardware" by using self-developed core technologies.',
	about3 : 'Corporate events',
	about4 : 'start',
	about5 : 'AI-Tech establish',
	about6 : 'The first robot',
	about7 : 'TFI prototype was developed and put into production.',
	about8 : 'Obtain software copyright',
	about9 : 'AI intelligent control and voice management system has been put into commercial use and applied for national software copyright.',
	about10 : 'English dialogue Online',
	about11 : 'AI intelligent English question and answer data platform (Intelligent English question and answer database) has been put into commercial use and applied for national software copyright.',
	about12 : 'Polymer skin put into use',
	about13 : 'The key new polymer material m-tpe has been put into the production and use of skin material for simulation robot body.',
	about14 : 'Mobile robot Online',
	about15 : 'The mobile attitude core algorithm and maintenance system are put into commercial use and applied for national software copyright.',
	about16 : 'Terminal management platform online',
	about17 : 'Based on the robot secondary development and terminal management platform, the system was put into commercial use. It is the core platform of robot secondary development and the core management and control platform of brain terminal.',
	about18 : 'Obtain software copyright',
	about19 : 'AI intelligent Chinese question and answer data platform (Intelligent Chinese question and answer database) was put into commercial use and applied for national software copyright.',
	about20 : 'Disinfection robot Online',
	about21 : 'The SRT-1 series of mobile spray disinfection robot prototype has been developed and put into production. On December 09, 2019, it obtained the national high tech enterprise certificate.',
	about22 : 'Robot input generation of mobile manipulator',
	about23 : 'The prototype srt-202 series of intelligent service (intelligent manipulator) robot has been developed and put into production.',
	about24 : 'UV lamp disinfection robot Online',
	about25 : 'SRT-3 series prototype of mobile UV lamp disinfection robot has been developed and put into production.',
	about26 : 'Scientific research achievements',
	about27 : 'In recent years, the company has made great efforts in R & D and achieved a lot of excellent results. Click to see more details',
	
	Contact1 : 'contact us',
	Contact2 : 'Address: 101, building A6, Meiying (Fenghuang) Zhihui Innovation Park, No.7 Xingye Third Road, Fenghuang community, Fuyong street, Bao an District, Shenzhen',
	Contact3 : 'Tel: + 86 0755-23226813',
	Contact4 : 'Mobile phone: +86 13421340682 miss ni',
	Contact5 : 'wechat & WhatsApp: + 86 13421340682',
	Contact6 : 'QQ：2571177189',
	Contact7 : 'E-mail：info@ai-aitech.com',
	Contact8 : 'Website address: www.ai-aitech.cn',
	Contact9 : 'Alibaba: https://airobot1688.1688.com/',
	
	regist1 : 'Get to know it now',
	regist2 : 'Full name：',
	regist3 : 'Please enter name',
	regist4 : 'Telephone：',
	regist5 : 'Input Telephone number',
	regist6 : 'Mailbox：',
	regist7 : 'Please enter email ',
	regist8 : 'Message：',
	regist9 : 'Submit',
	regist10 : 'For example, I want to know about disinfection robots',
	
	technology1 : 'Self research system and platform',
	technology2 : 'In 2017, English intelligent voice database and intelligent voice management system will be launched. In 2019, Chinese AI data platform, background robot terminal management platform, mobile control and attitude maintenance algorithm will be launched.',
	technology3 : 'Intelligent welcome robot',
	technology4 : '1. Own independent intellectual property rights (patent: 201821461522.1 / cn201811033797)',
	technology5 : '2.The whole robot mainly includes: intelligent mobile platform (mobile money) / intelligent simulation robot',
	technology6 : '3.Multilingual (including Chinese and English)',
	technology7 : '4.Intelligent or voice guidance for fixed-point, regular explanation or propaganda of the specified content',
	technology8 : '5.Content can be intelligently retrieved, compiled or customized',
	technology9 : '6.A single set can be remotely controlled independently, and multiple sets can be remotely clustered and synchronized',
	technology10 : 'Intelligent disinfection robot',
	technology11 : '1.Own independent intellectual property rights (patent: 2020sr017740 / cn201811185794.8)',
	technology12 : '2.The whole robot mainly includes: intelligent mobile platform / intelligent sterilization and killing platform',
	technology13 : '3.Multilingual (including 13 languages, including China, English, Germany, etc.)',
	technology14 : '4.Human machine co-existence (no need to leave during disinfection)',
	technology15 : '5.Multiple disinfection mode selection (free selection and setting for different environment)',
	technology16 : '6.AI intelligent control, remote response',
	technology17 : 'Agency certification',
	technology18 : 'Enterprise qualification',
	technology19 : 'Intelligent hardware platform',
	technology20 : 'Key new materials',
	
	homedis1 : 'Home smart disinfector',
	homedis2 : 'Intelligent High-power and high-frequency suspension atomization system: the disinfectant liquid is almost uniformly micronized to make it stay in the air for a longer time; 5-100 μ m negative charge disinfectant particles - automatic tracking, dust removal and sterilization are both correct.',
	homedis3 : 'Liquid filling operation',
	homedis4 : 'Product parameters',
	homedis5 : 'Specification and size',
	homedis6 : '225mm*225mm*295mm',
	homedis7 : 'Maximum water capacity',
	homedis8 : '3000ml',
	homedis9 : 'Spray quantity (adjustable)',
	homedis10 : '240～480g(=Water quantityml)/Hr.',
	homedis11 : 'Total power',
	homedis12 : '28W',
	homedis13 : 'Aerosol particles of disinfectant',
	homedis14 : '5～100μm',
	homedis15 : 'Stagnant time of disinfectant particles (after atomization)',
	homedis16 : '1～6Hr.',
	homedis17 : 'input voltage',
	homedis18 : 'AC 110～220V 50Hz',
	homedis19 : 'Single continuous working time',
	homedis20 : '6～12Hr.',
	homedis21 : 'Main structure',
	homedis22 : 'Digital display function',
	homedis23 : 'Video introduction',
	homedis24 : 'Intelligent disinfection and purification machine'
}